<template>
	<div class="container">
		<div class="server">
			<div class="server-img">
				<div class="server-img-content">
					<div class="server-ic-view">
						<h2 class="server-ic-view-h2">短工招聘服务</h2>
						<h4 class="server-ic-view-h4">短期工附近定位招人</h4>
						<div>
							<button class="server-ic-view-btn" type="button">申请服务</button>
						</div>
					</div>
				</div>
			</div>
			<div class="server-body">
				
				<h2 class="server-body-sup-title1">我们的服务</h2>
				<h4 class="server-body-sup-h4">就近定位需求</h4>
				
				<div class="server-body-view">
					<div class="server-body-view-title">可提供的人员包括：</div>
					<div class="server-body-view-list">
						<div class="server-body-view-item" v-for="(s,i) in 3" :key="i"><img :src="`../../../static/person_0${i+1}.png`" alt=""></div>
					</div>
				</div>
				
				<div class="server-body-1">
				<div class="server-body-1-content">
					<div class="call-me">
						<div class="call-me-1">免费电话回拨</div>
						<div class="call-me-2"><input type="text" class="call-me-input" placeholder="手机号"><button  class="call-me-btn" type="button">快联系我</button></div>
						<div class="call-me-3">服务时间: 09:30-18:30</div>
						<div class="call-me-4">马上发布职位</div>
					</div>
					<h2 class="server-body-sup-title server-body-sup-title-1">我们的流程</h2>
					<div class="server-body-1-list">
						<div class="server-body-1-item"  v-for="(s,i) in post" :key="i">
							<div class="server-body-1-head">
								<div :class="[`server-body-1-title`,`server-body-1-title${i+1}`]">
									<div :class="[`server-body-1-title-sub`,`server-body-1-title-sub${i+1}`]">{{s.title}}</div>
								</div>
								<div class="server-body-1-img" v-if="i != post.length - 1"><img class="server-body-1-icon" :src="`../../../static/Guide0${i+1}.png`" alt=""></div>
							</div>
							<div class="server-body-1-view">
								{{s.sub_title}}
							</div>
						</div>
					</div>
				</div>
			</div>

				<h2 class="server-body-sup-title2">我们的优势</h2>
				<div class="server-body-sup">
					<div class="server-body-sup-list">
						<div class="server-body-sup-item" v-for="(s,i) in sup" :key="i">
							<div class="server-body-sup-img">
								<img :src="s.img" alt="">
							</div>
							<div class="server-body-sup-txt">
								<div class="server-body-sup-t">{{s.title}}</div>
								<div class="server-body-sup-sub">{{s.sub_title}}</div>
							</div>
						</div>
					</div>
					<div class="server-body-sup-list">
						<div class="server-body-sup-item" v-for="(s,i) in sup1" :key="i">
							<div class="server-body-sup-img">
								<img :src="s.img" alt="">
							</div>
							<div class="server-body-sup-txt">
								<div class="server-body-sup-t">{{s.title}}</div>
								<div class="server-body-sup-sub">{{s.sub_title}}</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'EnterprieServerTwo',
		data(){
			return {
				sup: [
					{
						title:'海量资源',
						sub_title:'每月上千万求职在在播聘寻求工作',
						img:'../../../static/sup_1.png'
					},
					{
						title:'批量搜索',
						sub_title:'根据职位要求，批量的筛选搜寻，以确保 人员匹配',
						img:'../../../static/sup_2.png'
					}
				],
				sup1:[
					{
						title:'快速对接',
						sub_title:'通过IM、电话、短信等方式，以保证 批量的快速对接',
						img:'../../../static/sup_3.png'
					},
					{
						title:'丰富的行业经验',
						sub_title:'在兼职招聘、中长期岗位招聘上， 积累了丰富经验',
						img:'../../../static/sup_4.png'
					}
				],
				post:[
					{
						title:'职位分析',
						sub_title:'分析职位工作内容/地址/ 人员要求等, 明确关键条件'
					},
					{
						title:'匹配人员',
						sub_title:'对简历进行初筛后, 批量联系 确认意愿/安排面试等环节'
					},
					{
						title:'人员聘用',
						sub_title:'协助企业完成人员聘用 与到岗清点'
					},
					{
						title:'培训融入',
						sub_title:'入职前的准备, 协助完成 培训等事宜'
					}
				],
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("./enterprise-server-two.css");
</style>



// WEBPACK FOOTER //
// src/pages/enterprise-server-two/enterprise-server-two.vue